import type {
  IAiOnboardingSoftwareSelection,
} from '@pharmaplan/common';

interface ISoftwareOption {
  softwareId: string;
}

export const mergeSoftwareCatalog = (
  selectedSoftwares: IAiOnboardingSoftwareSelection[],
  softwareOptions: ISoftwareOption[],
): IAiOnboardingSoftwareSelection[] => {
  if (softwareOptions.length === 0) {
    return selectedSoftwares;
  }

  const selectedLevels = new Map(
    selectedSoftwares.map(({ expLevel, softwareId }) =>
      [
        softwareId,
        expLevel,
      ]),
  );

  return softwareOptions.map(({ softwareId }) =>
    ({
      expLevel: selectedLevels.get(softwareId) ?? 1,
      softwareId,
    }));
};
